import { FunctionalComponent, h } from "@stencil/core";
import clsx from "clsx";

import { renderMarkdown } from '../../../utils/markdown';

interface ContentProps {
  content: string;
  classes?: string;
}

export const Content: FunctionalComponent<ContentProps> = (props) => {
  const {
    content,
    classes,
  } = props;

  return (
    <div
      class={clsx("hr-content hr-content-before", classes)}
      innerHTML={renderMarkdown(content)}
    />
  )
}
